<template>
  <main>
    <div class="container-fluid">
      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button class="nav-link active" id="realtime-gender-content-tab" data-bs-toggle="pill" data-bs-target="#realtime-gender-content"
            type="button" role="tab" aria-controls="realtime-gender-content" aria-selected="true"> 性別即時 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sum-gender-content-tab" data-bs-toggle="pill" data-bs-target="#sum-gender-content" 
            type="button" role="tab" aria-controls="sum-gender-content" aria-selected="false">性別統計 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link" id="sum-age-content-tab" data-bs-toggle="pill" data-bs-target="#sum-age-content" 
            type="button" role="tab" aria-controls="sum-age-content" aria-selected="false">年齡統計 </button>
        </li>
      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <real-time-gender></real-time-gender>
        <sum-gender></sum-gender>
        <sum-age></sum-age>
      </div>
    </div>
  </main>
</template>

<script>
import realTimeGender from './realTimeGender.vue'
import sumGender from './sumGender.vue'
import sumAge from './sumAge.vue'



export default {
  components: { realTimeGender, sumGender, sumAge},
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
